<template>
     <el-select v-model="currentValue"  :multiple="multiple"
    filterable
    :remote="remote"
    placeholder="请填写关键词"
    :remote-method="remoteMethod"
    :loading="loading"
	@change="change"
    :disabled="disabled">
    <el-option
      v-for="item in currentOptions"
      :key="item[autoValue||label]"
      :label="item[label||autoValue]"
      :value="item[autoValue||label]">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'wt-auto-complete',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    autoValue: {
      type: String,
      default: 'value'
    },
    label: {
      type: String,
      default: 'label'
    },
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function () {
        return []
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    remoteRequestData: {
      type: Function
    }
  },
  data () {
    return {
      currentValue: this.value,
      loading: false,
      currentOptions: this.options
    }
  },
  methods: {
    _fullData (data) {
      this.currentOptions = data
    },
    remoteMethod (val) {
      this.remoteRequestData && this.remoteRequestData(val, (data) => {
        this._fullData(data)
        this.loading = false
      })
    },
    option_push (item) {
      this.currentOptions.push({
        [this.autoValue]: item[this.autoValue],
        [this.label]: item[this.label]
      })
    },
    change (val) {
      this.$emit('input', val)
      this.currentOptions.forEach(item => {
        if (item[this.autoValue || this.label] === val) {
          this.$emit('change', item)
        }
      })
    }
  },
  created () {
    // this.remoteMethod()
  }
}
</script>
<style lang="less">
</style>
